import { ref, watch } from 'vue';

/*
    Code which handles PAGINATION functionality
*/
export function usePagination(
    queryParams,
    resultsStore,
) {

    /*
        totalPages: gives us the total number of pages of results,
        calculated every time the results change
    */
    const totalPages = ref(0);

    function setTotalPages() {

        if (resultsStore.pageInfo) {
            totalPages.value = Math.ceil(resultsStore.pageInfo.totalCount / queryParams.params.limit);
        }
        
    }

    watch(resultsStore, () => {
        setTotalPages();
    });

    setTotalPages();
    
    /*
        currentPage: gives us the current result page,
        calculated every time the query parameters change
    */
    const currentPage = ref(0);

    function setCurrentPage() {
        currentPage.value = Math.ceil(queryParams.params.offset / queryParams.params.limit) + 1;
    }

    watch(queryParams.params, () => {
        setCurrentPage();
    });

    setCurrentPage();

    /*
        gotoPage: a function which updates the query parameters 
        to a given page number.
        'previous' and 'next' are also accepted as arguments
    */
    function gotoPage(page) {

        if (typeof(page) === 'number') {

        queryParams.updateParamString('offset', (page - 1) * queryParams.params.limit);

        } else if (page === 'previous') {

            queryParams.updateParamString('offset', queryParams.params.offset - queryParams.params.limit);

        } else if (page === 'next') {

            queryParams.updateParamString('offset', queryParams.params.offset + queryParams.params.limit);

        }

    }

    return { 
        currentPage,
        gotoPage,
        totalPages,
    }
}
